import React, { useState, useEffect } from "react";
import ReactDropdown from "react-dropdown";
import { NhanVayCombo } from "constants/nhanVayConst";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { ChoVayCombo } from "constants/choVayConst";
import CauHinhApi from "../../service/cauHinhApi";
import cauHinh from "utils/cauHinh";
import userApi from "service/userApi";

export const SearchBar = ({ onSearch, setDataSearch, dataSearch }) => {
  const [SuDungMaNhanVien, setSuDungMaNhanVien] = useState(false);
  const [listNhanVien, setListNhanVien] = useState([]);
  useEffect(() => {
    GetConfig();
  }, []);

  const GetConfig = () => {
    CauHinhApi.getConfigSys1().then((response) => {
      if (response.status === 200) {
        if (response.data.length > 0) {
          const isSuDungMaNhanVien = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.SuDungMaNhanVien.toUpperCase()
          );
          if (isSuDungMaNhanVien != null) {
            if (isSuDungMaNhanVien.valueConfig === "1") {
              setSuDungMaNhanVien(true);
              userApi.combo().then((response) => {
                if (response.status === 200) {
                  const users = response.data.map((item) => ({
                    value: item.value == "0" ? "" : item.value,
                    label: item.label,
                  }));
                  setListNhanVien(users);
                }
              });
            }
          }
        }
      }
    });
  };

  const updateState = (field, text) => {
    setDataSearch({
      ...dataSearch,
      [field]: text,
    });
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateDropdown = (field) => (e) => {
    updateState(field, e.value);
  };

  const handle1KeyDown = (event) => {
    if (event.key === "Enter") {
      setDataSearch({
        ...dataSearch,
        pageIndex: 1,
      });
      onSearch(dataSearch);
    }
  }; //sự kiện tìm kiếm enter

  const ClickSearch = () => {
    dataSearch.iPageIndex = 1;
    setDataSearch(dataSearch);
    onSearch(dataSearch);
  }; //sự kiện tìm kiếm enter
  return (
    <div
      className="card border-light mb-3 mt-1 hidden-mobile-main show-table-main card-v2"
      style={{ marginTop: "-8px" }}
    >
      <div className="card-body card-body-v2">
        <div className="search-new">
          <div className="input-sm-new input-new-18">
            <label
              htmlFor="customer-name"
              className="font-color-default font-bold"
            >
              Tìm kiếm
            </label>
            <input
              type="text"
              className="form-control input-sm"
              placeholder="Tên, SĐT, CCCD, mã HĐ, mã TS"
              onChange={updateTextValue("sSearch")}
              onKeyDown={handle1KeyDown}
              value={dataSearch.sSearch}
            />
          </div>
          <div className="input-sm-new input-new-18">
            <label
              htmlFor="customer-name"
              className="font-color-default font-bold"
            >
              Trạng Thái
            </label>
            <ReactDropdown
              onChange={updateDropdown("iStatus")}
              options={ChoVayCombo.NgayPhaiTraCombo1}
              placeholder="Select an option"
              controlClassName="form-control input-sm"
              arrowClassName=""
              value={dataSearch.iStatus}
            />
          </div>
          <div className="input-sm-new input-new-18">
            <label
              htmlFor="customer-name"
              className="font-color-default font-bold"
            >
              Loại hợp đồng
            </label>
            <ReactDropdown
              onChange={updateDropdown("iType")}
              options={ChoVayCombo.KieuVayCombo}
              placeholder="Select an option"
              controlClassName="form-control input-sm"
              arrowClassName=""
              value={dataSearch.iType}
            />
          </div>

          {SuDungMaNhanVien && (
            <div className="input-sm-new input-new-18">
              <label
                htmlFor="customer-name"
                className="font-color-default font-bold"
              >
                Chọn nhân viên
              </label>
              <ReactDropdown
                onChange={updateDropdown("sMaNhanVien")}
                options={listNhanVien}
                placeholder="Chọn nhân viên"
                controlClassName="form-control input-sm"
                value={dataSearch.sMaNhanVien}
              />
            </div>
          )}

          <div className="input-sm-new input-new-10 search-main-new">
            <button
              type="submit"
              className="btn btn-info-new btn-seach-ds"
              onClick={(e) => ClickSearch()}
            >
              <i className="la la-search"></i>
              <span> &nbsp; Tìm kiếm</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
